import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_HEALTH_INSURANCE } from './get-health-insurance.hook';
import { GET_HEALTH_INSURANCE_BY_ID } from './get-health-insurance-by-id.hook';
import { GET_HEALTH_INSURANCE_BY_IDS } from './get-health-insurance-by-ids.hook';
import { GET_ALL_HEALTH_INSURANCE } from './get-all-health-insurance.hook';

export const UPDATE_HEALTH_INSURANCE = gql`
  mutation updateEmployeeQuestionnaireSetting($payload: UpdateHealthInsuranceInput!) {
    updateHealthInsurance(payload: $payload) {
      _id
    }
  }
`;

export const useUpdateHealthInsurance = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { t } = useTranslation('settings');
  const [updateHealthInsurance, { loading }] = useMutation(UPDATE_HEALTH_INSURANCE, {
    onCompleted: data => {
      if (data?.updateHealthInsurance?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('healthInsurance.notifications.updated'),
        });
        if (onSuccess) {
          onSuccess();
        }
      }
    },
    refetchQueries: [
      GET_HEALTH_INSURANCE,
      GET_HEALTH_INSURANCE_BY_ID,
      GET_HEALTH_INSURANCE_BY_IDS,
      GET_ALL_HEALTH_INSURANCE,
    ],
  });

  return { updateHealthInsurance, loading };
};
